import * as React from 'react';
import { useImmerReducer } from 'use-immer';
import { NotWorthIt, FixMe } from '../types/util';
import { ITrainingSet } from '../types/my-types';

interface IMarkState {
  openAddNoteModal: boolean;
  openViewDocumentModal: boolean;
  viewDocumentPages: string[];
  viewDocumentId: string | null;
  createTrainingSetModal: boolean;
  createExtractionBatchModal: boolean;
  trainingSetLabel: string;
  extractionBatchLabel: string;
  selectedTrainingSet: ITrainingSet | undefined;
}

const initialState: IMarkState = {
  openAddNoteModal: false,
  openViewDocumentModal: false,
  viewDocumentPages: [],
  viewDocumentId: null,
  createTrainingSetModal: false,
  createExtractionBatchModal: false,
  trainingSetLabel: '',
  extractionBatchLabel: '',
  selectedTrainingSet: undefined,
};

function documentReducer(draft: FixMe, action: NotWorthIt) {
  switch (action.type) {
    case 'SET_SELECTED_TRAINING_SET':
      draft.selectedTrainingSet = action.trainingSet;
      return;
    case 'SET_TRAINING_SET_LABEL':
      draft.trainingSetLabel = action.label;
      return;
    case 'SET_EXTRACTION_BATCH_LABEL':
      draft.extractionBatchLabel = action.label;
      return;
    case 'TOGGLE_CREATE_TRAINING_SET_MODAL':
      draft.createTrainingSetModal = !draft.createTrainingSetModal;
      return;
    case 'TOGGLE_CREATE_EXTRACTION_BATCH_MODAL':
      draft.createExtractionBatchModal = !draft.createExtractionBatchModal;
      return;
    case 'TOGGLE_ADD_NOTE_MODAL':
      draft.openAddNoteModal = !draft.openAddNoteModal;
      return;
    case 'TOGGLE_VIEW_DOCUMENT_MODAL':
      draft.openViewDocumentModal = !draft.openViewDocumentModal;
      draft.viewDocumentPages = action.pages || [];
      draft.viewDocumentId = action.id || null;
      return;
    default:
      return;
  }
}

const defaultDispatch: React.Dispatch<any> = () => initialState;

export const DocumentStateContext = React.createContext(initialState);
export const DocumentDispatchContext = React.createContext<React.Dispatch<any>>(defaultDispatch);

export const DocumentContextProvider = (props: NotWorthIt) => {
  const [state, dispatch] = useImmerReducer<IMarkState, IMarkState>(documentReducer, initialState);
  return (
    <DocumentDispatchContext.Provider value={dispatch}>
      <DocumentStateContext.Provider value={state}>{props.children}</DocumentStateContext.Provider>
    </DocumentDispatchContext.Provider>
  );
};
